import {
  LiveManagementLivecarpDTO,
  LiveManagementLivecarpItemDTO,
} from "@/common/api";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class LiveModule extends VuexModule {
  public items: LiveManagementLivecarpItemDTO[] = null;
  public live: LiveManagementLivecarpDTO = null;
  public image: null;
  public config: {
    method: "all";
    range: {
      start: null;
      end: null;
    };
    is_display_code: true;
    date: {
      year: null;
      month: null;
      day: null;
    };
    signature: "";
  };

  @Mutation
  public setLive(live: LiveManagementLivecarpDTO): void {
    this.live = live;
  }

  @Action
  public updateLive(live: LiveManagementLivecarpDTO) {
    this.context.commit("setLive", live);
  }

  @Mutation
  public setLiveItems(items: LiveManagementLivecarpItemDTO[]): void {
    this.items = items;
  }

  @Action
  public updateLiveItems(items: LiveManagementLivecarpItemDTO[]) {
    this.context.commit("setLiveItems", items);
  }

  @Mutation
  public setConfig(config): void {
    this.config = config;
  }

  @Action
  public updateConfig(config) {
    this.context.commit("setConfig", config);
  }

  @Mutation
  public setImage(image): void {
    this.image = image;
  }

  @Action
  public updateImage(image) {
    this.context.commit("setImage", image);
  }
}
